import { useState } from 'react';
import toast from 'react-hot-toast';

import { downloadUrl } from '../../../utils/download';
import { useTranslation } from 'contexts/translation-context';
import { constructDownloadUrl } from '../models';

export function useDownloadDocument() {
  const { i18n } = useTranslation();
  const [downloadingFiles, setDownloadingFiles] = useState<string[]>([]);

  const downloadFile = async (file: { id: string; hash: string; name: string }) => {
    setDownloadingFiles((files) => [...files, file.id]);

    const url = constructDownloadUrl({
      documentId: file.id,
      documentHash: file.hash,
    });
    downloadUrl(url, {
      openInNewTab: true,
    });

    toast.success(i18n('download.started'));

    setDownloadingFiles((files) => files.filter((id) => id !== file.id));
  };

  return {
    downloadFile,
    downloadingFiles,
  };
}
